import { Sparkles } from "lucide-react"
import { AskDynamoPawIllustration } from "~/components/AskDynamoPawIllustration"
import { substituteDogName } from "~/utils/substituteDogName"

interface AskDynamoSignupCalloutProps {
  dogName: string
  exampleQuestion: string
}

export function AskDynamoSignupCallout({ dogName, exampleQuestion }: AskDynamoSignupCalloutProps) {
  const question = substituteDogName(exampleQuestion, dogName)

  return (
    <section
      className="rounded-2xl border border-[var(--color-ask-dynamo)]/20 bg-gradient-to-br from-[var(--color-ask-dynamo-surface)] to-white/80 p-4 shadow-[0_6px_24px_rgba(108,61,242,0.1)]"
      aria-labelledby="signup-ask-dynamo-heading"
    >
      <div className="flex items-start gap-3">
        <AskDynamoPawIllustration className="h-12 w-12 shrink-0" />
        <div className="min-w-0 flex-1">
          <h2
            id="signup-ask-dynamo-heading"
            className="flex items-center gap-1.5 text-base font-semibold text-[var(--color-ask-dynamo-muted)]"
          >
            Meet Ask Dynamo
            <Sparkles size={14} className="text-[var(--color-ask-dynamo)]" aria-hidden />
          </h2>
          <p className="mt-2 text-sm italic leading-relaxed text-[var(--color-text-primary)]">
            &ldquo;{question}&rdquo;
          </p>
          <p className="mt-2 text-sm text-[var(--color-text-secondary)]">
            Get answers tailored to {dogName}&apos;s unique personality.
          </p>
        </div>
      </div>
    </section>
  )
}
